import React from "react";
import Api from "../../../Helper/ApiHandler";
import { useEffect } from "react";
import { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import { useParams } from "react-router-dom";
import { Grid } from "@chakra-ui/react";
import "react-lazy-load-image-component/src/effects/blur.css";
import { trackWindowScroll } from "react-lazy-load-image-component";
import TableLoader from "../../../Components/Common/TableLoader";
import { PhotoBookImage } from "./PhotoBookImage";

const PhotoBookTab = ({ Id }) => {
  const api = new Api();
  const [totalcount, setTotalCount] = useState();
  const [card, setCard] = useState([]);
  const [page, setPage] = useState(1);
  let { id } = useParams();
  const [Loading, setLoading] = useState(false);
  const getCardData = async (pageData) => {
    setLoading(true);
    const listOfAlbum = await api.post(`${"user/photobook-list"}`, {
      page: pageData ? pageData : page,
      userId: id,
    });

    setLoading(false);
    setTotalCount(listOfAlbum?.data[0]?.totalCount[0]?.count);
    setPage(page + 1);
    setCard((prev) => [...prev, ...listOfAlbum.data[0].pages]);
  };
  useEffect(() => {
    setPage(1);
    setCard([]);
    getCardData(1);
  }, [id]);

  return (
    <>
      <TableLoader isLoading={Loading} version={6} />
      <InfiniteScroll
        dataLength={card.length}
        next={getCardData}
        style={{ display: "flex", flexDirection: "column" }} //To put endMessage and loader to the top.
        height="70vh  "
        hasMore={card.length != totalcount}
        className="design-scrollbar"
        loader={
          card.length ? (
            <h4>Loading...</h4>
          ) : (
            !Loading && <h4>No Photobook Found</h4>
          )
        }
        endMessage={<></>}
      >
        {
          <Grid templateColumns={"50% 50%"}>
            {card.map((currentvalue, index) => {
              return (
                <>
                  <PhotoBookImage currentvalue={currentvalue} index={index} />
                </>
              );
            })}
          </Grid>
        }
      </InfiniteScroll>
    </>
  );
};

export default trackWindowScroll(PhotoBookTab);
